import { render, staticRenderFns } from "./TangiblesIdentification.vue?vue&type=template&id=1a72f50a"
import script from "./TangiblesIdentification.vue?vue&type=script&lang=js"
export * from "./TangiblesIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports